import React from 'react';
import Quiz from 'react-quiz-component';



export default function QuizModal(param) {

    const [quizList, setQuizList] = React.useState('');          



    function quizListMake() {
        var list = {
            "quizTitle": "React Quiz Component Demo",
            "quizSynopsis": "Lorem ipsum dolor sit amet, consectetuer adipiscing elit. Aenean commodo ligula eget dolor. Aenean massa. Cum sociis natoque penatibus et magnis dis parturient montes, nascetur ridiculus mus. Donec quam felis, ultricies nec, pellentesque eu, pretium quis, sem. Nulla consequat massa quis enim",
            "questions" : param.quizList
        }
        setQuizList(list)
    }

    function quizModalClose() {
        param.callbackQuizSendData();
    }

    return(
        <div className="modal fade" id="quizModal" data-keyboard="false" data-backdrop="static" tabIndex="-1" role="dialog" aria-labelledby="exampleModalLabel" aria-hidden="true">
            <div className="modal-dialog modal-xl  modal-dialog-centered">
                <div className="modal-content">
                
                    <div className="modal-header">
                        <h4 className="modal-title">퀴즈 미리보기</h4>
                        <button type="button" className="close" data-dismiss="modal" onClick={quizModalClose}>&times;</button>
                    </div>
                    
                    <div className="modal-body">
                        <Quiz quiz={param.quizList} shuffle={true} showInstantFeedback={true} continueTillCorrect={true}/>
                    </div>
                </div>
            </div>
        </div>
    );
}